/* THE LABEL — theme.js (vanilla, no dependencies) */
(() => {
  'use strict';

  const T = window.theme || { routes: {}, strings: {} };
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const root = (T.routes.root || '/').replace(/\/?$/, '/');
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const store = {
    get(key, fallback) { try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ } }
  };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- Money ---------- */
  function formatMoney(cents, format = T.moneyFormat || '{{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = (n, decimals, thousands = ',', dec = '.') => {
      if (isNaN(n) || n == null) return '0';
      const fixed = (n / 100).toFixed(decimals);
      const [ints, frac] = fixed.split('.');
      return ints.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`) + (frac ? dec + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Overlays: drawers, search, modals ---------- */
  const scrim = $('[data-scrim]');
  let lastFocus = null;
  let openCount = 0;

  function lock(on) {
    openCount = Math.max(0, openCount + (on ? 1 : -1));
    document.body.classList.toggle('is-locked', openCount > 0);
    if (!scrim) return;
    if (openCount > 0) { scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('is-visible')); }
    else { scrim.classList.remove('is-visible'); setTimeout(() => { if (openCount === 0) scrim.hidden = true; }, 300); }
  }

  function openDrawer(name) {
    const drawer = $(`[data-drawer="${name}"]`);
    if (!drawer || drawer.classList.contains('is-open')) return;
    closeAll();
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    lock(true);
    if (name === 'wishlist') renderWishlist();
    setTimeout(() => drawer.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    lock(false);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  function openSearch() {
    const el = $('[data-search-overlay]');
    if (!el) return;
    closeAll();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    lock(true);
    setTimeout(() => $('[data-predictive-input]', el)?.focus(), 60);
  }
  function closeSearch() {
    const el = $('[data-search-overlay]');
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    lock(false);
  }
  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('is-locked');
    $('[data-modal-close].modal__close', modal)?.focus();
  }
  function closeModal(modal) {
    modal.hidden = true;
    if (openCount === 0) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  function closeAll() {
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      const name = opener.dataset.openDrawer;
      if (name === 'cart' && T.cartType === 'page') return;
      e.preventDefault();
      openDrawer(name);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(e.target.closest('.drawer')); return; }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-search-close]')) { closeSearch(); return; }
    if (e.target.matches('[data-scrim]')) { closeAll(); return; }
    const mo = e.target.closest('[data-modal-open]');
    if (mo) { openModal(mo.dataset.modalOpen); return; }
    const mc = e.target.closest('[data-modal-close]');
    if (mc) { closeModal(mc.closest('[data-modal]')); return; }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const modal = $$('[data-modal]').find((m) => !m.hidden);
    if (modal) return closeModal(modal);
    const lb = $('[data-lightbox]:not([hidden])');
    if (lb) return closeLightbox(lb);
    closeAll();
    closeMega();
  });

  /* ---------- Header: sticky state, height, mega menu ---------- */
  const headerWrap = $('[data-header]');
  function setHeaderHeight() {
    if (!headerWrap) return;
    document.documentElement.style.setProperty('--header-h', `${headerWrap.offsetHeight}px`);
  }
  setHeaderHeight();
  window.addEventListener('resize', debounce(setHeaderHeight, 150));
  const onScroll = () => headerWrap && headerWrap.classList.toggle('is-scrolled', window.scrollY > 10);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  let megaTimer;
  function openMega(trigger) {
    clearTimeout(megaTimer);
    const panel = document.getElementById(trigger.dataset.megaTrigger);
    if (!panel) return;
    $$('[data-mega].is-open').forEach((p) => p !== panel && p.classList.remove('is-open'));
    $$('[data-mega-trigger]').forEach((t) => t.setAttribute('aria-expanded', t === trigger ? 'true' : 'false'));
    panel.classList.add('is-open');
    headerWrap && headerWrap.classList.add('is-open');
  }
  function closeMega() {
    $$('[data-mega].is-open').forEach((p) => p.classList.remove('is-open'));
    $$('[data-mega-trigger]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
    headerWrap && headerWrap.classList.remove('is-open');
  }
  $$('[data-mega-trigger]').forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => { clearTimeout(megaTimer); megaTimer = setTimeout(() => openMega(trigger), 80); });
    trigger.addEventListener('focus', () => openMega(trigger));
  });
  $$('.header__navlink:not([data-mega-trigger])').forEach((l) => l.addEventListener('mouseenter', () => { clearTimeout(megaTimer); closeMega(); }));
  if (headerWrap) {
    headerWrap.addEventListener('mouseleave', () => { clearTimeout(megaTimer); megaTimer = setTimeout(closeMega, 120); });
    $$('[data-mega]').forEach((p) => p.addEventListener('mouseenter', () => clearTimeout(megaTimer)));
    headerWrap.addEventListener('focusout', (e) => { if (!headerWrap.contains(e.relatedTarget)) closeMega(); });
  }

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, parseInt(bar.dataset.interval, 10) || 5000);
  });

  /* ---------- Footer columns collapse on mobile ---------- */
  if (window.matchMedia('(max-width: 749px)').matches) $$('[data-footer-col]').forEach((d) => d.removeAttribute('open'));

  /* ---------- Predictive search ---------- */
  const searchInput = $('[data-predictive-input]');
  const searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    const fallback = searchResults.innerHTML;
    let controller;
    const run = debounce(async () => {
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = fallback; return; }
      controller && controller.abort();
      controller = new AbortController();
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = parseHTML(await res.text());
        const section = doc.querySelector('.shopify-section') || doc.body;
        searchResults.innerHTML = section.innerHTML;
        syncWishlistButtons(searchResults);
      } catch (err) {
        if (err.name !== 'AbortError') searchResults.innerHTML = fallback;
      }
    }, 220);
    searchInput.addEventListener('input', run);
  }

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => (el.textContent = count));
    $$('[data-cart-count-badge]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
  }
  function replaceCartDrawer(html) {
    if (!html) return;
    const current = $('[data-cart-drawer]');
    const doc = parseHTML(html);
    const next = doc.querySelector('[data-cart-drawer]');
    if (!current || !next) return;
    const wasOpen = current.classList.contains('is-open');
    if (wasOpen) next.classList.add('is-open');
    current.replaceWith(next);
  }
  async function refreshCount() {
    try { const cart = await (await fetch(`${root}cart.js`)).json(); updateCartCount(cart.item_count); } catch (e) { /* ignore */ }
  }

  async function addToCart(variantId, quantity = 1, button) {
    if (button) button.classList.add('is-loading');
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }], sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      await refreshCount();
      if (T.cartType === 'page') { window.location.href = T.routes.cart; return true; }
      replaceCartDrawer(data.sections && data.sections['cart-drawer']);
      openDrawer('cart');
      return true;
    } catch (err) {
      toast(err.message || T.strings.error);
      return false;
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  async function changeLine(line, quantity) {
    const drawer = $('[data-cart-drawer]');
    drawer && drawer.classList.add('results-loading');
    try {
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)), sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      updateCartCount(data.item_count);
      replaceCartDrawer(data.sections && data.sections['cart-drawer']);
    } catch (err) {
      toast(err.message || T.strings.error);
      drawer && drawer.classList.remove('results-loading');
    }
  }

  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) { changeLine(qtyBtn.dataset.cartQty, qtyBtn.dataset.qty); return; }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart(quick.dataset.quickAdd, 1, quick); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-input]');
    if (input) changeLine(input.dataset.cartInput, input.value);
  });

  /* ---------- Wishlist (stored on this device) ---------- */
  const WISH_KEY = 'thelabel:wishlist';
  const getWish = () => store.get(WISH_KEY, []);
  function syncWishlistButtons(scope = document) {
    const list = getWish();
    $$('[data-wishlist-toggle]', scope).forEach((btn) => btn.setAttribute('aria-pressed', list.includes(btn.dataset.handle) ? 'true' : 'false'));
    $$('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.dataset.count = list.length; });
    $$('[data-wishlist-count-text]').forEach((el) => (el.textContent = list.length ? `(${list.length})` : ''));
    $$('[data-wishlist-count-label]').forEach((el) => (el.textContent = `(${list.length})`));
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.handle;
    let list = getWish();
    const has = list.includes(handle);
    list = has ? list.filter((h) => h !== handle) : [handle, ...list].slice(0, 60);
    store.set(WISH_KEY, list);
    syncWishlistButtons();
    toast(has ? T.strings.wishlistRemoved : T.strings.wishlistAdded);
    const drawer = $('[data-drawer="wishlist"]');
    if (drawer && drawer.classList.contains('is-open')) renderWishlist();
  });

  async function fetchCard(handle, sectionId) {
    try {
      const res = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=${sectionId}`);
      if (!res.ok) return null;
      const doc = parseHTML(await res.text());
      return doc.querySelector('[data-product-card]');
    } catch (e) { return null; }
  }
  async function renderWishlist() {
    const wrap = $('[data-wishlist-items]');
    const empty = $('[data-wishlist-empty]');
    if (!wrap) return;
    const list = getWish();
    empty && (empty.hidden = list.length > 0);
    wrap.innerHTML = '';
    if (!list.length) return;
    const cards = await Promise.all(list.slice(0, 24).map((h) => fetchCard(h, 'wishlist-item')));
    const missing = [];
    cards.forEach((card, i) => { if (card) wrap.appendChild(card); else missing.push(list[i]); });
    if (missing.length) store.set(WISH_KEY, getWish().filter((h) => !missing.includes(h)));
    syncWishlistButtons();
    if (!wrap.children.length && empty) empty.hidden = false;
  }
  syncWishlistButtons();

  /* ---------- Rails ---------- */
  $$('[data-rail-section]').forEach((section) => {
    const track = $('[data-rail-track]', section);
    if (!track) return;
    const prev = $('[data-rail-prev]', section);
    const next = $('[data-rail-next]', section);
    const bar = $('[data-rail-progress]', section);
    const step = () => track.clientWidth * 0.8;
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = max > 0 ? track.scrollLeft / max : 0;
      const visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      if (bar) { bar.style.width = `${Math.max(visible * 100, 8)}%`; bar.style.transform = `translateX(${ratio * (1 / Math.max(visible, 0.08) - 1) * 100}%)`; }
      prev && (prev.disabled = track.scrollLeft < 4);
      next && (next.disabled = track.scrollLeft > max - 4);
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    const jsonEl = $('[data-product-json]');
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const product = data.product;
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const stock = $('[data-stock]', section);
    const priceWrap = $('[data-price-wrap]', section);
    const sticky = $('[data-sticky-atc]');
    const stickyBtn = $('[data-sticky-add]');
    const stickyPrice = $('[data-sticky-price]');
    const fieldsets = $$('fieldset[data-option-index]', section);
    const track = $('[data-gallery-track]', section);

    // Recently viewed
    const RV = 'thelabel:recent';
    store.set(RV, [product.handle, ...store.get(RV, []).filter((h) => h !== product.handle)].slice(0, 12));

    const selected = () => fieldsets.map((fs) => ($('input:checked', fs) || {}).value);
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));

    const priceHTML = (v, cls) => {
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      return `<div class="price${sale ? ' price--sale' : ''} ${cls}"><span class="price__current">${formatMoney(v.price)}</span>${sale ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s>` : ''}</div>`;
    };

    function markAvailability(opts) {
      fieldsets.forEach((fs, i) => {
        $$('input[data-option-input]', fs).forEach((input) => {
          const ok = product.variants.some((v) => v.available && v.options[i] === input.value && v.options.slice(0, i).every((o, j) => o === opts[j]));
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update(fromInit) {
      const opts = selected();
      fieldsets.forEach((fs, i) => { const l = $('[data-option-selected]', fs); if (l) l.textContent = opts[i] || ''; });
      markAvailability(opts);
      const v = findVariant(opts);
      const strings = T.strings;
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable; }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? strings.addToBag : strings.soldOut; }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? strings.addToBag : strings.soldOut; }
      if (priceWrap) priceWrap.innerHTML = priceHTML(v, 'product__price');
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(v, 'small');
      if (stock) {
        const inv = data.inventory[v.id] || {};
        stock.classList.remove('stock--low', 'stock--out');
        if (!v.available) { stock.classList.add('stock--out'); stock.textContent = strings.soldOut; }
        else if (inv.managed && data.lowStock > 0 && inv.qty > 0 && inv.qty <= data.lowStock) { stock.classList.add('stock--low'); stock.textContent = (stock.dataset.low || '__N__').replace('__N__', inv.qty); }
        else stock.textContent = stock.dataset.in || stock.textContent;
      }
      if (!fromInit) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (v.featured_media && track) {
          const item = $(`[data-media-id="${v.featured_media.id}"]`, track);
          if (item) {
            if (window.matchMedia('(min-width: 990px)').matches) {
              const first = track.firstElementChild;
              if (first && item !== first) track.insertBefore(item, first);
            } else {
              track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
            }
          }
        }
      }
    }

    fieldsets.forEach((fs) => fs.addEventListener('change', () => update(false)));
    update(true);

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const err = $('[data-form-error]', section);
        err && (err.hidden = true);
        const ok = await addToCart(idInput.value, 1, addBtn);
        if (!ok && err) { err.textContent = T.strings.error; err.hidden = false; }
      });
    }
    if (stickyBtn) stickyBtn.addEventListener('click', () => addToCart(idInput.value, 1, stickyBtn));

    // Sticky add-to-bag on phones
    const anchor = $('[data-buy-anchor]', section);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn && (stickyBtn.tabIndex = show ? 0 : -1);
      }).observe(anchor);
    }

    // Gallery dots
    const dots = $$('[data-dot]', section);
    if (track && dots.length) {
      track.addEventListener('scroll', debounce(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      }, 60), { passive: true });
      dots.forEach((d) => d.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * Number(d.dataset.dot), behavior: 'smooth' })));
    }

    // Lightbox
    const lightbox = $('[data-lightbox]');
    if (lightbox && track) {
      const open = (index) => {
        lightbox.hidden = false;
        document.body.classList.add('is-locked');
        const lbTrack = $('[data-lightbox-track]', lightbox);
        const target = $(`.lightbox__item[data-index="${index}"]`, lightbox) || lbTrack.firstElementChild;
        if (target) lbTrack.scrollTo({ left: target.offsetLeft });
        $('[data-lightbox-close]', lightbox).focus();
      };
      track.addEventListener('click', (e) => { const item = e.target.closest('[data-zoom]'); if (item) open(item.dataset.index); });
      track.addEventListener('keydown', (e) => { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-zoom]')) { e.preventDefault(); open(e.target.dataset.index); } });
      $('[data-lightbox-close]', lightbox).addEventListener('click', () => closeLightbox(lightbox));
    }

    // Size guide tabs
    $$('[data-tabs]').forEach((tabs) => {
      $$('[data-tab]', tabs).forEach((tab) => tab.addEventListener('click', () => {
        $$('[data-tab]', tabs).forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); document.getElementById(t.dataset.tab).hidden = !on; });
      }));
    });
  }
  function closeLightbox(lb) { lb.hidden = true; if (openCount === 0) document.body.classList.remove('is-locked'); }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- Recommendations & recently viewed ---------- */
  $$('[data-recommendations]').forEach(async (section) => {
    try {
      const res = await fetch(section.dataset.url);
      const doc = parseHTML(await res.text());
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { section.innerHTML = fresh.innerHTML; syncWishlistButtons(section); }
    } catch (e) { /* leave empty */ }
  });
  $$('[data-recently-viewed]').forEach(async (section) => {
    const current = ($('[data-product-section]') || {}).dataset?.productHandle;
    const handles = store.get('thelabel:recent', []).filter((h) => h !== current).slice(0, Number(section.dataset.limit) || 4);
    if (!handles.length) return;
    const wrap = $('[data-recently-viewed-items]', section);
    const cards = (await Promise.all(handles.map((h) => fetchCard(h, 'wishlist-item')))).filter(Boolean);
    if (!cards.length) return;
    cards.forEach((c) => wrap.appendChild(c));
    section.hidden = false;
    syncWishlistButtons(section);
  });

  /* ---------- Filters & sorting (Section Rendering API) ---------- */
  async function renderResults(url, push = true) {
    const rootEl = $('[data-results-root]');
    if (!rootEl) { window.location.href = url; return; }
    const sectionId = rootEl.dataset.section;
    rootEl.classList.add('results-loading');
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      const res = await fetch(u.toString());
      const doc = parseHTML(await res.text());
      const fresh = doc.querySelector('[data-results-root]');
      if (!fresh) throw new Error('No results');
      // Keep open/closed state of filter groups
      const openState = $$('.facets-sidebar details.facet', rootEl).map((d) => d.open);
      rootEl.innerHTML = fresh.innerHTML;
      $$('.facets-sidebar details.facet', rootEl).forEach((d, i) => { if (openState[i] !== undefined) d.open = openState[i]; });
      if (push) { u.searchParams.delete('section_id'); window.history.pushState({ results: true }, '', u.toString()); }
      syncWishlistButtons(rootEl);
      document.body.classList.remove('is-locked');
      openCount = 0;
      if (scrim) { scrim.classList.remove('is-visible'); scrim.hidden = true; }
    } catch (e) {
      window.location.href = url;
    } finally {
      rootEl.classList.remove('results-loading');
    }
  }
  function urlFromForm(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => { if (value !== '') params.append(key, value); });
    const sort = $('[data-sort-select]');
    if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    else if (sort) params.set('sort_by', sort.value);
    return `${window.location.pathname}?${params.toString()}`;
  }
  const applyDesktop = debounce((form) => renderResults(urlFromForm(form)), 350);
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (form && form.closest('.facets-sidebar')) applyDesktop(form);
    const sort = e.target.closest('[data-sort-select]');
    if (sort) {
      const u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      renderResults(u.toString());
    }
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    renderResults(urlFromForm(form));
  });
  document.addEventListener('click', (e) => {
    const apply = e.target.closest('[data-facets-apply]');
    if (apply) { const form = document.getElementById(apply.dataset.facetsApply); if (form) renderResults(urlFromForm(form)); return; }
    const link = e.target.closest('[data-facet-link]');
    if (link && $('[data-results-root]')) { e.preventDefault(); renderResults(link.href); }
  });
  window.addEventListener('popstate', (e) => { if ($('[data-results-root]')) renderResults(window.location.href, false); });

  /* ---------- Designers directory search ---------- */
  const designerInput = $('[data-designer-filter]');
  if (designerInput) {
    designerInput.addEventListener('input', () => {
      const q = designerInput.value.trim().toLowerCase();
      let any = false;
      $$('[data-designer-group]').forEach((group) => {
        let visible = 0;
        $$('[data-designer-name]', group).forEach((a) => { const show = !q || a.dataset.designerName.includes(q); a.hidden = !show; if (show) visible++; });
        group.hidden = visible === 0;
        if (visible) any = true;
      });
      const none = $('[data-designer-none]');
      if (none) none.hidden = any;
    });
  }

  /* ---------- Customer login: recover password toggle ---------- */
  const recover = $('#RecoverForm');
  const login = $('#LoginForm');
  if (recover && login) {
    const show = (r) => { recover.hidden = !r; login.hidden = r; };
    $$('[data-toggle-recover]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); show(recover.hidden); }));
    if (window.location.hash === '#recover') show(true);
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', () => { setHeaderHeight(); syncWishlistButtons(); });
})();
